export default {"src":"/kelp/_next/static/media/x_kernel.b0e640b1.svg","height":33,"width":37,"blurWidth":0,"blurHeight":0};